<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Tipo de Serviço | {{id}}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
          <div class="form-group col-12 col-md-6">
            <label for="descricao">Descrição: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.descricao }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="observacao">Observação: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.observacao }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="status_desc">Status: &nbsp;&nbsp;&nbsp;</label>
            <span class="label" v-bind:class="{
                'label-success': registro.idc_status === 1,
                'label-danger': registro.idc_status === 2,
                'label-default': ![1,2].includes(registro.idc_status)
              }">{{ registro.status_desc }}</span>
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="observacao">Instalação: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.instalacao_desc }}
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Voltar</button>
            <button type="button" id="editarButton" class="btn btn-info" @click="editar()">Editar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Actions from '../../actions/ServicoTipoActions'

export default {
  name: 'detalhes',
  props: ['id'],
  data () {
    return {
      registro: {
        descricao: '',
        observacao: '',
        idc_status: '',
        status_desc: '',
        idc_instalacao: '',
        instalacao_desc: ''
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Detalhes'

    Actions.obterTipoServico(this.id)
      .then(res => {
        if (res && res.descricao) {
          this.registro = res
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }
      })
      .catch((error) => {
        console.log(error.message)
        this.errorMessage = 'Registro não encontrado.'
      })
  },
  methods: {
    voltar () {
      this.$router.push('/servico-tipo')
    },
    editar () {
      this.$router.push('/servico-tipo/' + this.id + '/e')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/servico-tipo/Detalhes.vue